import {
  getEnv, ORIGINACION_WT, PAGOSERVICIOS, PLAYSTORE_APP_LINK,
} from '../api/env';

/* eslint-disable max-len */
const BANNERS = [
  {
    image: '/images/carousel-01.png',
    title: 'Cuando lo necesitas, estamos.',
    description: 'Pedí un <b>préstamo, pagá tus servicios</b>, hacé tus compras <b>con QR</b> y <b>pagá después</b>.',
    ctaLabel: '¡Sacá tu préstamo!',
    link: getEnv(ORIGINACION_WT),
  },
  {
    image: '/images/carousel-02.png',
    title: 'Préstamos 100% online',
    description: 'Solicitá hoy hasta <b>$3.000.000</b> en hasta 36 cuotas fijas y recibilo en el acto.',
    ctaLabel: '¡Pedí tu préstamo!',
    link: getEnv(ORIGINACION_WT),
  },
  {
    image: '/images/carousel-03.png',
    title: 'Pagá todos tus servicios',
    description: 'Usá tu crédito disponible para <b>pagar en cuotas</b> o en <b>30 días</b> tus facturas.',
    ctaLabel: '¡Pagalo hoy!',
    link: getEnv(PAGOSERVICIOS),
  },
  {
    image: '/images/carousel-04.png',
    title: 'Usá nuestra app',
    description: '¿Sos cliente? Simplificá tu vida con nuestra app. Hacé <b>compras con QR, sacá otro prestamo, mira tus cuotas, pagá</b> y muchas cosas mas.',
    ctaLabel: 'Descargá la app',
    link: `${getEnv(PLAYSTORE_APP_LINK)}?id=ar.com.credicuotas.autogestion.twa`,
  },
];

export default BANNERS;
